export class UserLog {
  constructor(
    public username: string | null,
    public operationType: string | null,
    public targetUser: string,
    public dateTime: string,
    public details: Details
  ) { }
}

export class Details {
  constructor(
    public companiesAdd: number | null,
    public companiesRemove: number | null,
    public permissionsAdd: string[] | null,
    public permissionsRemove: string[] | null,
    public groupsAdd: string[] | null,
    public groupsRemove: string[] | null,
    public changedIsActive: any,
    public changedIsSuperuser: any,
    public changedPassword: any,
    public hasChanges: boolean,
    public hasMoreInfo: boolean
  ) { }
}


export class PaginationInfo {
  constructor(
    public count: number,
    public total: number,
    public hasNextPage: boolean,
    public hasPreviousPage: boolean,
    public startCursor: string | null,
    public endCursor: string | null
  ) { }
}
